module.exports = __webpack_public_path__ + "21a71a245ed421588e6047df09782be0.png";